module.exports = __webpack_public_path__ + "img/cqsw.ad52f54c.png";